export default {
  VALIDATE: 'VALIDATE',
  VALIDATE_REPRESENTATIVE_DNI: 'VALIDATE_REPRESENTATIVE_DNI',
  VALIDATE_DNICIF: 'VALIDATE_DNICIF'
}
